import script from "./profile-natural-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./profile-natural-page.vue?vue&type=script&lang=ts&setup=true"

import "./profile-natural-page.vue?vue&type=style&index=0&id=50ef26f3&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ef26f3"]])

export default __exports__